export const FEATURE_AI_SEARCH = "MT AI Search";
export const FEATURE_AI_SEARCH_DS_AI = "MT AI Search DS-AI";

export const AI_SEARCH_QUERY_PARAM = 'search';
export const AI_SEARCH_ANSWER_PARAM = 'searchAnswer';
// Carries the question on the AI-search route itself, before it's known which
// page the answer belongs on.
export const AI_SEARCH_ROUTE_PARAM = 'query';

export const BYO_WORDS_QUERY_PARAM_NAME = 'words';
export const BYO_WORDS_COUNT_QUERY_PARAM_NAME = 'wordsCount';
export const BYO_SETTINGS_ID_QUERY_PARAM_NAME = 'byoSettingId';
export const BYO_INSTANT_CHART_ID_QUERY_PARAM_NAME = 'instantChartId';
export const DEFAULT_SCROLLBAR_SIZE = 10;
export const DEFAULT_GROWTH_PERIOD = 4;

export const MENU_EXAMPLES_COUNTS: Record<string, { dishes: string; menus: string }> = {
    USA: { dishes: '36 million', menus: '600,000' },
    CAN: { dishes: '2 million', menus: '50,000' },
};